/*
const serverTime = new Date(current_date_time).getTime();
const serverStartTime = new Date(serverTime);

function updateTime() {
      serverStartTime.setSeconds(serverStartTime.getSeconds() + 1);
      document.getElementById('current-server-time').textContent = serverStartTime.toLocaleTimeString();
    }

    // Display initial time and start the interval
    document.getElementById('current-server-time').textContent = serverStartTime.toLocaleTimeString();
    setInterval(updateTime, 1000);
*/
function getServerDate(serverDateString, setDays, setMidnight) {
    // Parse the server-provided date (format: YYYY-MM-DD)
    const serverDate = new Date(serverDateString);
    const modDays = setDays;
    const modMidnight = setMidnight;
    let modDate;
    if (modMidnight == 1) {
      console.log("MIDNIGHT!");
      modDate = new Date(serverDate.getFullYear(), serverDate.getMonth(), serverDate.getDate() + modDays, 0, 0, 0); // Midnight
    } else {
      console.log("NOT MIDNIGHT!");
      modDate = new Date(serverDate.getFullYear(), serverDate.getMonth(), serverDate.getDate() + modDays, serverDate.getHours(), serverDate.getMinutes(), serverDate.getSeconds());
    }
    return modDate;
  }

  // Dynamically set targetDate to tomorrow's date
  const targetDate = getServerDate(current_date_time, 1, 1);
  console.log("Target Date: " + targetDate);

  // Initialize server time
  let actualServerTime = getServerDate(current_date_time, 0, 0);
  console.log("Initial Actual Server Time: " + actualServerTime);

  // Track the start time
  const startTime = Date.now();

  function updateCountdown() {
    // Increment actualServerTime based on the elapsed time
    actualServerTime = new Date(actualServerTime.getTime() + 1000);

    const difference = targetDate - actualServerTime;

    if (difference <= 0) {
      document.getElementById('countdown').textContent = "Time's up!";
      return;
    }

    // Calculate time components
    const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((difference / (1000 * 60)) % 60);
    const seconds = Math.floor((difference / 1000) % 60);

    // Display the countdown
    document.getElementById('countdown').innerHTML =
      `${hours.toString().padStart(2, '0')}:` +
      `${minutes.toString().padStart(2, '0')}:` +
      `${seconds.toString().padStart(2, '0')}` +
      `<div class="christmas-time-left">Don't Miss This Deal!</div>`;
  }

  // Update every second
  setInterval(updateCountdown, 1000);

  // Initialize the countdown
  updateCountdown();